import React, {Component} from 'react';
import {Button, Form, Header, Icon, Popup} from 'semantic-ui-react';
import {CollapsiblePanel, Toggle} from '../universal/collapsiblePanel';
import ItemsListView from "./items_list";
import ReportContainer from "../../containers/report_container";
import AddNewDataToReport from "./add_new_data";
import AdditionalRoomPhotos from "../report/additional_room_photos"

class GroupsListView extends Component {

    constructor(props) {
        super(props);
        this.state = {
            activeIndex: 0,
            attachments: [],
            showEdit: undefined,
            deleteCalled: false,
            groupName: undefined,
            openGroups:false
        }
    }

    updateGroupDetails = (roomIndex, groupIndex, group) => {
        if (!group.action) {
            group['action'] = 'update';
        }
        group['name'] = this.state.groupName;
        this.props.updateGroupInReport(roomIndex, groupIndex, group);
        this.setState({showEdit: undefined});
    };

    render() {
        const groups = this.props.groups;
        const isExpanded = this.props.forceActive;
        return (<div>
            <Header textAlign="left" className='pad-top'> <span className="format-underlined">Groups </span>{!isExpanded && <Icon name= {this.state.openGroups ?"compress":"expand"} className="icon-button pull-right" color="grey" size="small" onClick={() => {this.setState({openGroups:!this.state.openGroups})}}/>}</Header>
            <CollapsiblePanel>
                {this.props.groups ? groups.map((group, i) => {
                    return <Toggle group={true} topAmt={115}key={group['client_id']} ref={group['client_id']} forceActive={isExpanded || this.state.openGroups}
                                   title={<div className="field " style={{display: 'inline'}}>
                                       {this.state.showEdit === group['client_id'] &&
                                       <div className="ui input report-inputs" style={{width: '675px'}}>
                                           <Form onSubmit={() => {
                                               this.updateGroupDetails(this.props.roomIndex, i, group)
                                           }} style={{width:'100%'}}>
                                               <input type="text"
                                                      defaultValue={group.name}
                                                      placeholder="Group Name"
                                                      autoFocus
                                                      required
                                                      maxLength="255"
                                                      onFocus={(e) => {
                                                          this.setState({groupName: e.target.value})
                                                      }}
                                                      onChange={(e) => {
                                                          this.setState({groupName: e.target.value})
                                                      }}
                                                      onBlur={() => {
                                                          if(this.state.groupName.length > 1){
                                                              this.setState({showEdit: undefined});
                                                              this.updateGroupDetails(this.props.roomIndex, i, group)
                                                          }
                                                      }}
                                               />
                                           </Form>
                                       </div>}
                                       {this.state.showEdit !== group['client_id'] &&
                                       <span className="report-field-name" onClick={(e) => {
                                           if (this.props.reportDetails['inspection_type'] !== 'co'|| this.props.reportDetails['inspection_type'] === 'co'&& this.props.other_template) {
                                               this.setState({showEdit: group['client_id']})
                                           }
                                       }}>{group.name}</span>}
                                       {(this.props.reportDetails['inspection_type'] !== 'co' || this.props.reportDetails['inspection_type'] === 'co'&& this.props.other_template)&&
                                       <div style={{display: 'inline'}} className="pull-right">

                                           <Popup
                                               trigger={<Icon name="trash"
                                                              size='large'
                                                              color='grey'
                                               />}
                                               content={<Button negative content="Confirm Delete Group?"
                                                                onClick={(e) => {
                                                                    this.props.deleteGroupFromReport(this.props.roomIndex, i,group['room_id']);
                                                                    this.setState({deleteCalled: !this.state.deleteCalled})
                                                                }}/>}
                                               on="click"
                                               position="right center"
                                               hideOnScroll
                                           />

                                       </div>}
                                   </div>}>
                        <ItemsListView items={group.items} other_template={this.props.other_template} reportType={this.props.reportType}
                                       groupId={group['client_id']} roomIndex={this.props.roomIndex} groupIndex={i}
                                       reportId={this.props.reportId} forceActive={isExpanded} openGroups={this.state.openGroups}/>
                                        <AdditionalRoomPhotos group={true} roomClientId={group.client_id}inspectionId={this.props.reportDetails['inspection_id']}></AdditionalRoomPhotos> 
                    </Toggle>
                }) : null}
            </CollapsiblePanel>
            <AddNewDataToReport type='Group' reportId={this.props.reportId} roomId={this.props.roomId}
                roomIndex={this.props.roomIndex} other_template={this.props.other_template}/>
        </div>);
    }
}

export default ReportContainer(GroupsListView);


// WEBPACK FOOTER //
// ./src/views/report/groups_list.js